import React, { useState } from "react";
import "../Style/appdevdoubts.css";

import arrowIcon from "../assets/blue-arrow.png";

const faqData = [
  {
    question: "How long does it take to develop a mobile app?",
    answer:
      "The development timeline depends on your app's complexity, features, and platform requirements. A basic mobile app typically takes 6–10 weeks, while medium to enterprise-level applications may require 3–6 months or more. At MPeoples, we follow an agile development process to deliver quality applications on schedule.",
  },
  {
    question: "How much does mobile app development cost?",
    answer:
      "The cost of mobile app development depends on the project scope, features, UI/UX design, integrations, and supported platforms. Simple applications cost less, while enterprise apps with advanced functionality require a larger investment. Contact MPeoples for a customized quote based on your business requirements.",
  },
  {
    question: "Will my app work on both Android and iOS?",
    answer:
      "Yes. We develop mobile applications for Android, iOS, and cross-platform frameworks like Flutter. Depending on your goals and budget, we'll recommend the best technology to maximize performance and reach.",
  },
  {
    question: "Can you redesign or upgrade my existing mobile app?",
    answer:
      "Absolutely. We modernize outdated mobile applications by improving the user interface, adding new features, enhancing performance, fixing bugs, and upgrading the app to the latest technologies while preserving your existing data whenever possible.",
  },
  {
    question: "Will my mobile app be secure?",
    answer:
      "Yes. Security is a core part of our development process. We implement secure authentication, encrypted data transmission, API protection, role-based access control, and follow industry best practices to safeguard your application and user data.",
  },
  {
    question: "Can you integrate third-party services into my app?",
    answer:
      "Yes. We integrate payment gateways, Google Maps, Firebase, cloud services, social media logins, CRMs, ERP systems, SMS gateways, analytics platforms, push notifications, and other third-party APIs based on your business requirements.",
  },
  {
    question: "Do you provide app maintenance and support?",
    answer:
      "Yes. Our post-launch support includes performance monitoring, bug fixes, security updates, feature enhancements, operating system compatibility updates, server maintenance, and ongoing technical support to keep your app running smoothly.",
  },
];

const Appdoubt = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="appdoubts-section">
      <div className="appdoubts-container">
        <span className="appdoubts-eyebrow">FAQ</span>

        <h2 className="appdoubts-title">
          Frequently Asked Questions About Mobile App Development
        </h2>

        <div className="appdoubts-faq-grid">
          {faqData.map((item, index) => (
            <div
              className={`appdoubts-faq-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="appdoubts-faq-question-row"
                onClick={() => toggleFaq(index)}
              >
                <span className="appdoubts-faq-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h3 className="appdoubts-faq-question">{item.question}</h3>

                <button className="appdoubts-faq-btn" aria-label="Toggle answer">
                  <img
                    src={arrowIcon}
                    alt=""
                    className={`appdoubts-faq-icon ${
                      activeIndex === index ? "rotate" : ""
                    }`}
                  />
                </button>
              </div>

              <div
                className={`appdoubts-faq-answer-wrapper ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <div className="appdoubts-faq-answer-inner">
                  <p className="appdoubts-faq-answer">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Appdoubt;